<!-- PAGE HEADER -->

<div class="page-header">
    <h2>Business Verification</h2>
</div>

<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium" color="#ffffff" type="ball-spin-clockwise" [fullScreen]="true">
</ngx-spinner>

<div class="container pt-24">

    <form [formGroup]="businessVerificationForm">

        <div class="step-note">
            To unlock vaccine pricing and set up your Employee Voucher Program,
            please enter your business's Employer Identification Number (EIN)
            and upload a completed IRS Form W-9.
        </div>

        <!-- EIN + STATUS -->

        <div class="ein-row">

            <div class="ein-field">

                <label>
                    <span>* </span>Employer Identification Number (EIN)
                </label>

                <input pInputText type="text" formControlName="ein" maxlength="10" inputmode="numeric"
                    placeholder="XX-XXXXXXX" mask="00-0000000" [validation]="true" [dropSpecialCharacters]="true"
                    class="ein-input" />


                <small class="p-error" *ngIf="businessVerificationForm.get('ein')?.hasError('required')
              && businessVerificationForm.get('ein')?.touched">
                    EIN is required.
                </small>

                <small class="p-error" *ngIf="businessVerificationForm.get('ein')?.hasError('pattern')
              && businessVerificationForm.get('ein')?.touched">
                    Please enter a valid EIN (XX-XXXXXXX).
                </small>

            </div>

            <div class="status-container">

                <span class="status-label">

                    Business Verification Status:

                    <span [ngClass]="verificationStatus=='Complete'
                        ? 'status-complete'
                        : 'status-incomplete'">

                        {{verificationStatus}}

                    </span>

                </span>

            </div>

        </div>

        <!-- Upload Section -->

        <div class="border-box">

            <div class="required-note">

                By uploading a current and completed IRS Form W-9 ("W-9"), the
                submitting business, organization, or individual certifies
                that the information provided is true, correct and complete,
                and that they are authorized to act on behalf of the entity
                identified on the form. Submission of a W-9 serves as
                verification of the submitter's association with, and authority
                to represent, the named business or organization.

            </div>

            <div class="required-note">

                Knowingly providing false, fictitious, or fraudulent
                information on a W-9 is a violation of U.S. federal law.
                Falsifying or misrepresenting taxpayer identification
                information may subject the individual or entity to civil
                penalties, criminal penalties, or both, including fines and
                potential prosecution under applicable federal statutes.

            </div>

            <div class="required-note">

                By submitting a W-9, the submitter acknowledges these
                responsibilities and legal obligations.

            </div>

            <div class="field">

                <label class="required-label">
                    * Accepted files: pdf or jpg with a maximum file size of 5 MB
                </label>

                <div class="upload-container">

                    <button type="button" class="upload-btn" (click)="triggerFileSelect()">

                        Browse for File

                    </button>

                </div>

                <p-fileUpload #fileUploadRef mode="advanced" name="file" [multiple]="false" [auto]="false"
                    [customUpload]="true" accept=".pdf,.jpg,.jpeg" [maxFileSize]="5242880" [showUploadButton]="false"
                    [showCancelButton]="false" (onSelect)="onFileSelect($event)" (onRemove)="onFileRemove()"
                    (onError)="onFileError($event)">

                    <ng-template pTemplate="header">
                    </ng-template>

                </p-fileUpload>

                <small class="p-error" *ngIf="businessVerificationForm.get('w9File')?.invalid &&
           businessVerificationForm.get('w9File')?.touched">
                    W-9 file is required.
                </small>

            </div>

        </div>

        <div class="actions mt-30 mb-30">
            <button type="button" (click)="cancel()">Close</button>
            <button type="submit" (click)="submitBusinessVerification()" [disabled]="!isFileValid || fileSizeError">
                Save
            </button>
        </div>

    </form>

</div>

<p-dialog header="{{ dialogSummary }}" [(visible)]="locListModalDlg" [closable]="false" [modal]="true"
    [dismissableMask]="false" [style]="{ width: '40vw' }">

    <div class="dialog-body" [innerHTML]="dialogMsg">
    </div>

    <ng-template pTemplate="footer">

        <div class="actions">

            <ng-container *ngIf="dialogType==='unsaved'">

                <button class="button-secondary" (click)="stayOnPage()">

                    Continue Setup

                </button>

                <button class="button-primary" (click)="leavePage()">

                    Leave

                </button>

            </ng-container>

            <ng-container *ngIf="dialogType!=='unsaved'">

                <button class="button-primary" (click)="okClicked()">

                    Ok

                </button>

            </ng-container>

        </div>

    </ng-template>

</p-dialog>